module.exports = __webpack_public_path__ + "static/media/15UN-Habitat13.23c01791.jpg";